import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "49px",
	height: "64px",
	viewBox: "0 0 49 64",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Logo/Zanichelli/Z-icon" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Symbols",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Logo/Zanichelli/Z-icon-logo",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Logo/Zanichelli/Z-icon",
					children: [/* @__PURE__ */ _jsx("polygon", {
						id: "Fill-1",
						fill: "#E2001A",
						points: "0 64 49 64 49 0 0 0"
					}), /* @__PURE__ */ _jsx("polygon", {
						id: "Fill-2",
						fill: "#FEFEFE",
						points: "13.0737854 9.93103448 37.4898733 9.93103448 37.4898733 18.6740272 22.1906018 46.2662178 37.8636364 46.2662178 37.8636364 54.0689655 11.1363636 54.0689655 11.1363636 45.4531488 26.4356351 17.7330677 13.0737854 17.7330677"
					})]
				})
			})
		})
	]
});
export default SvgZLogo;
